import { createApp } from "vue";
import { ModalHelper } from "../../B2bTools";
import hash from "../../hash";

import Fuse from 'fuse.js'

import html from "./seasonExclusEdit.html";
import htmlSeasonExclusEditName from "./seasonExclusEdit@name.html";
import htmlProducts from "./seasonExclusEdit@products.html";
import Store from "../../Store"; 

const js = ({
    url: function (echangeur) {
        
        let u = Store.get('getURUL')();
        if(!echangeur.hash.u) echangeur.hash.env= u;
        echangeur.addAction('b2b.toc.editExclus', echangeur.hash, '', 'form');
        echangeur.addAction('b2b.toc.productListExclus', echangeur.hash, '', 'product');
    },
    onLoad: function (echangeur) {
        const form = echangeur.form
        const _id = echangeur.hash._id
        const sid = echangeur.hash.sid

        let THIS = this;

        const app = createApp({
            data: () => ({
                form: form,
                product: echangeur.product.rows,
                _id: _id,
                sid: sid,
            }),
            methods: {
                back() {
                    hash.fin();
                },
                edit() {
                    const thisParent = this;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                saisie: form.v
                            }
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            async save() {
                                if (this.saisie !== '') {
                                    const copyForm = { ...form, v: this.saisie }
                                    const response = await THIS.rest("b2b.toc.nameSaveExclus", { _id, sid, }, copyForm);
                                    if (response.ok) {
                                        thisParent.form.v = response.sdoc.v
                                        this.close();
                                    }
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonExclusEditName).container);
                },
                editProducts() {
                    const thisParent = this
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                form: form,
                                product: echangeur.product.rows,
                                //
                                fuse: null,
                                search: null,
                                searchKey: null,
                                //
                                checkeds: false,
                                id: _id,
                            }
                        },

                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },

                            async save() {
                                const references = this.product.map(u => u.reference);
                                this.form.products = this.form.products.filter(u => (references.indexOf(u) >= 0))
                                const result = await THIS.rest("b2b.toc.productSaveExclus", { "_id": thisParent._id, "sid": thisParent.sid, }, this.form);
                                // console.log( thisParent.form , result.sdoc);
                                // throw 'stop'
                                thisParent.form = result.sdoc;
                                this.close();
                            },

                            selectAll() {
                                //console.log(fuse)
                                if (this.checkeds == false) {
                                    this.checkeds = true
                                    this.form.products = []
                                    for (let item of this.product) {
                                        this.form.products.push(item.reference)
                                    }
                                } else {
                                    this.checkeds = false
                                    this.form.products = []
                                }
                            },

                            lanceRecherche(val) {
                                this.search = this.fuse.search(val);
                                let indexSearch = this.search.map(e => {
                                    return e.item.reference;
                                });
                                let countUserAff = 0;
                                this.product.map(u => {
                                    u.inSearch = (indexSearch.indexOf(u.reference) > -1);
                                    if (u.show) countUserAff += 1;
                                })
                            },
                        },

                        watch: {
                            "searchKey"(val) {
                                this.lanceRecherche(val);
                            },
                            "form.products"() {
                                if (form.products.length != this.product.length) {
                                    this.checkeds = false
                                } else {
                                    this.checkeds = true
                                }
                            }
                        },

                        mounted() {
                            if (form.products.length == this.product.length) {
                                this.checkeds = true
                            } else {
                                this.checkeds = false
                            }
                            // Reset search
                            this.searchKey = ''
                            this.search = null

                            this.fuse = new Fuse(this.product, {
                                includeScore: false, threshold: 0.2, keys: ['reference']
                            });
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlProducts).container);
                },
                editCustomers() {
                    hash.lance("seasonExclusCustomers", { _id: _id, sid: form.sid });
                },
            }
        });

        app.mount(THIS.c$('._vueChargement')[0]);

    },

});

export default {
    seasonExclusEdit: { js: js, html: html }
};